import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { type AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import { type SplitSupplyNoticeSection } from '@ebalance/proto/bffuser/v1/split_supply_plan_model_pb'
import { listPartnerSplitSupplyNotices } from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'
import {
  ListPartnerSplitSupplyNoticesRequestSchema,
  type ListPartnerSplitSupplyNoticesResponse,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

import { type CivilDate, civilDateToProtoDate } from '~/models/civilDate'

type Params = {
  section: SplitSupplyNoticeSection
  /** 翌日の登録は受渡日、 月間の登録は対象月の 1 日。 */
  targetDate: CivilDate
  /** 未指定 = すべてのエリア。 */
  areaCode: AreaCode | undefined
}

/**
 * 他社の通告値の一覧 (1 行 = 登録 1 件、 登録日時の新しい順) の取得 hook。
 */
export function useListPartnerSplitSupplyNotices({
  section,
  targetDate,
  areaCode,
}: Params): UseQueryResult<
  ListPartnerSplitSupplyNoticesResponse,
  ConnectError
> {
  return useQuery(
    listPartnerSplitSupplyNotices,
    create(ListPartnerSplitSupplyNoticesRequestSchema, {
      section,
      targetDate: civilDateToProtoDate(targetDate),
      areaCode,
    }),
    // 本番の既定は throwOnError: true。 一覧の失敗は表の位置の案内 (再試行つき) で見せるので伝播させない
    { throwOnError: false },
  )
}
